import { Component, type ReactNode } from "react";
import { reportClientError } from "@/lib/reportError";
import { recoverFromChunkLoadError } from "@/lib/chunkRecovery";

interface Props {
  children: ReactNode;
  /** O que renderizar quando o elemento lazy falhar. */
  fallback: ReactNode;
  /** Rota que tentou carregar o chunk, sem inferir tudo como /home. */
  path: "/home" | "/personalizar-plano";
}

interface State {
  falhou: boolean;
}

/**
 * PlanoV2RouteBoundary — rede de segurança do elemento LAZY de /home.
 *
 * ⚠️ Correção do review adversarial (achado 3): com VITE_FEATURE_DIETA_V2 ON, o
 * Se o chunk não baixa (offline na primeira visita, hashes trocados ou cache
 * vazio), a barreira mostra indisponibilidade com retry. Falha de transporte
 * não pode classificar uma conta como legado.
 *
 * Fica FORA de src/pages/CardapioV2/ de propósito: este arquivo é eager, e um
 * import acidental de lá pra cá arrastaria o Sistema Vivo pro bundle principal.
 */
export class PlanoV2RouteBoundary extends Component<Props, State> {
  state: State = { falhou: false };

  static getDerivedStateFromError(): State {
    return { falhou: true };
  }

  componentDidCatch(error: Error) {
    console.error("[PlanoV2RouteBoundary] tela indisponível");
    // Observável: sem isto, um chunk quebrado em produção seria invisível — o
    // usuário veria o Home de sempre e ninguém saberia que o gate morreu.
    reportClientError({
      type: "plano_v2_gate",
      message: `chunk do Sistema Vivo falhou: ${error.name}: ${error.message}`,
      path: this.props.path,
    });
    recoverFromChunkLoadError(error);
  }

  render() {
    return this.state.falhou ? this.props.fallback : this.props.children;
  }
}
